import { Const } from "../../core/constants";
import {
  useThemeStore,
  FONT_CLASSES,
  THEME_OPTIONS,
} from "../stores/themeStore";

export function applyThemeClass(themeId: string): void {
  const html = document.documentElement;
  for (const option of THEME_OPTIONS) {
    html.classList.remove("theme-" + option.id);
  }
  html.classList.add("theme-" + themeId);
}

export function applyFontClass(fontId: keyof typeof FONT_CLASSES): void {
  const html = document.documentElement;
  for (const className of Object.values(FONT_CLASSES)) {
    if (className) html.classList.remove(className);
  }
  const next = FONT_CLASSES[fontId];
  if (next) html.classList.add(next);
}

/**
 * Copies the active theme's canvas custom properties into the mutable `Const`
 * color bag so `KarelView` draws with theme-aware colors.
 */
export function applyCanvasColors(): void {
  const style = getComputedStyle(document.documentElement);
  const read = (name: string, fallback: string): string => {
    const value = style.getPropertyValue(name);
    return value ? value.trim() : fallback;
  };
  Const.BACKGROUND_COLOR = read("--canvas-bg", Const.BACKGROUND_COLOR);
  Const.CANVAS_GRID_COLOR = read("--canvas-grid", Const.CANVAS_GRID_COLOR);
  Const.BEEPER_FILL_COLOR = read("--canvas-beeper", Const.BEEPER_FILL_COLOR);
  Const.CANVAS_WALL_COLOR = read("--canvas-wall", Const.CANVAS_WALL_COLOR);
  Const.CANVAS_TEXT_COLOR = read("--canvas-text", Const.CANVAS_TEXT_COLOR);
  Const.CANVAS_KAREL_STROKE = read(
    "--canvas-karel-stroke",
    Const.CANVAS_KAREL_STROKE,
  );
  Const.CANVAS_KAREL_FILL = read(
    "--canvas-karel-fill",
    Const.CANVAS_KAREL_FILL,
  );
}

/**
 * Applies the persisted theme, font, and canvas colors. Call once during
 * bootstrap, before the app renders, so the first canvas paint is correct.
 */
export function syncThemeFromStore(): void {
  const { themeId, fontId } = useThemeStore.getState();
  applyThemeClass(themeId);
  applyFontClass(fontId);
  applyCanvasColors();
}
